import { c as _c } from "react/compiler-runtime";
import { CategoryID } from '@sbt-web/network/types';
import { TextLink } from '@sbt-web/ui';
import { getOrCreatePulse } from '@/tools/tracking/utils';
import classes from './index.module.scss';
interface TipProps {
  tip: TipInterface;
  adUrn: string;
}
interface TipInterface {
  icon: string;
  copy: string;
  cssClass: string;
  link: string;
  linkCopy: string;
}
const MARKET_CATEGORIES_ID = [CategoryID.ConsoleVideogiochi, CategoryID.Informatica, CategoryID.AudioVideo, CategoryID.Fotografia, CategoryID.Telefonia, CategoryID.Elettronica, CategoryID.CasaPersona, CategoryID.ArredamentoCasalinghi, CategoryID.GiardinoFaiDaTe, CategoryID.AbbigliamentoAccessori, CategoryID.TuttoBambini, CategoryID.SportsHobby, CategoryID.MusicaFilm, CategoryID.LibriRiviste, CategoryID.StrumentiMusicali, CategoryID.Sports, CategoryID.Biciclette, CategoryID.Collezionismo];
const CASE_VACANZA_CATEGORY_ID = CategoryID.CaseVacanza;
const ANIMALI_CATEGORY_ID = CategoryID.Animali;
const caseVacanzaTip = {
  icon: 'doc',
  copy: 'segui i nostri consigli per ',
  cssClass: 'casa-vacanze',
  link: 'https://www.subito.it/magazine/trick-or-trip.html?from=ad_detail',
  linkCopy: 'affittare una casa vacanza in sicurezza'
};
const marketTip = {
  icon: 'lucchetto',
  copy: 'ecco come fare per evitare le truffe. ',
  cssClass: 'market',
  link: 'https://assistenza.subito.it/hc/it/articles/360001165545-I-consigli-sicuri-di-Subito-con-Polizia-Postale?from=ad_detail',
  linkCopy: 'Acquista in sicurezza'
};
const animaliTip = {
  icon: 'animale',
  copy: 'scopri come evitare le truffe. ',
  cssClass: 'market',
  link: 'https://assistenza.subito.it/hc/it/articles/360016431617-Animali?from=ad_detail',
  linkCopy: 'Leggi i nostri consigli'
};
const SafetyTips = t0 => {
  const $ = _c(6);
  const {
    category,
    adUrn
  } = t0;
  if (category === CASE_VACANZA_CATEGORY_ID) {
    let t1;
    if ($[0] !== adUrn) {
      t1 = <SafetyTip tip={caseVacanzaTip} adUrn={adUrn} />;
      $[0] = adUrn;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  if (category === ANIMALI_CATEGORY_ID) {
    let t1;
    if ($[2] !== adUrn) {
      t1 = <SafetyTip tip={animaliTip} adUrn={adUrn} />;
      $[2] = adUrn;
      $[3] = t1;
    } else {
      t1 = $[3];
    }
    return t1;
  }
  if (MARKET_CATEGORIES_ID.some(cat => cat === category)) {
    let t1;
    if ($[4] !== adUrn) {
      t1 = <SafetyTip tip={marketTip} adUrn={adUrn} />;
      $[4] = adUrn;
      $[5] = t1;
    } else {
      t1 = $[5];
    }
    return t1;
  }
  return null;
};
const trackingClick = (adUrn: string): void => {
  getOrCreatePulse()?.queueEvent({
    type: 'Engagement',
    object: {
      '@type': 'UIElement',
      '@id': `sdrn:subito:classified:${adUrn}:element:click-on-safety-tip`
    }
  });
};
const SafetyTip = t0 => {
  const $ = _c(19);
  const {
    adUrn,
    tip
  } = t0;
  const t1 = `/static/img/pillole-di-sicurezza/${tip.icon}.svg`;
  let t2;
  if ($[0] !== t1) {
    t2 = <div className={classes["safety-tips-icon"]}><img src={t1} alt="" width={32} height={32} /></div>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className="caption">Fai attenzione: </span>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== tip.copy) {
    t4 = <span className="caption book">{tip.copy}</span>;
    $[3] = tip.copy;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== adUrn) {
    t5 = () => {
      trackingClick(adUrn);
    };
    $[5] = adUrn;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== tip.linkCopy) {
    t6 = <span className="caption book">{tip.linkCopy}</span>;
    $[7] = tip.linkCopy;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t5 || $[10] !== t6 || $[11] !== tip.link) {
    t7 = <TextLink size="sm" href={tip.link} target="_blank" rel="noreferrer" onClick={t5}>{t6}</TextLink>;
    $[9] = t5;
    $[10] = t6;
    $[11] = tip.link;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t4 || $[14] !== t7) {
    t8 = <p>{t3}{t4}{t7}</p>;
    $[13] = t4;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t2 || $[17] !== t8) {
    t9 = <aside className={classes["safety-tips-wrapper"]}>{t2}{t8}</aside>;
    $[16] = t2;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return t9;
};
export default SafetyTips;